/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmailIcon = createIcon("EmailIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: "#0045DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 12H10a2 2 0 00-2 2v20a2 2 0 002 2h28a2 2 0 002-2V14a2 2 0 00-2-2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.946C8 12.871 8.89 12 10.002 12h27.996c1.106 0 2.002.882 2.002 1.946L25.593 24.8c-.88.663-2.322.65-3.186 0L8 13.946Z",
    fill: "#D8D8D8"
  }));
}, {
  "i18nKey": "svg.EmailIcon"
});